// Pre-order close for products with a `coffee.ships_on` date metafield.
//
// Pre-orders close at the end of the day before the release date, in Houston
// time: from 00:00 America/Chicago on `ships_on`, the product is "Not available".
// Liquid renders the right state at render time, but /pages/* and PDP HTML can
// be served from a stale edge cache, and a tab can sit open across midnight, so
// this script re-checks against the browser clock on load and every minute.
//
// Markup contract (PDP buy box, /pages/coffee cards, cart note):
//   [data-bic-preorder-close="YYYY-MM-DD"]  root, value = ships_on
//     [data-bic-preorder-open]              shown while pre-order is open
//     [data-bic-preorder-closed]            shown once it has closed
//     button[data-bic-preorder-disable]     disabled once closed; its
//                                           [data-bic-preorder-label] (or the
//                                           button itself) reads "Not available"
// On the cart page, any closed root inside #cart also blocks the checkout
// submit and hides the express-checkout wallets (html.bic-preorder-blocked).

(function () {
  if (window.bicPreorderInit) return;
  window.bicPreorderInit = true;

  function chicagoToday() {
    try {
      var parts = new Intl.DateTimeFormat('en-CA', {
        timeZone: 'America/Chicago', year: 'numeric', month: '2-digit', day: '2-digit'
      }).formatToParts(new Date()).reduce(function (a, p) { a[p.type] = p.value; return a; }, {});
      return parts.year + '-' + parts.month + '-' + parts.day;
    } catch (e) {
      return null;
    }
  }

  function isClosed(root) {
    var today = chicagoToday();
    var date = root.getAttribute('data-bic-preorder-close');
    return !!(today && date && today >= date);
  }

  function apply() {
    var blockCart = false;
    document.querySelectorAll('[data-bic-preorder-close]').forEach(function (root) {
      var closed = isClosed(root) || root.hasAttribute('data-bic-preorder-server-closed');
      if (!closed) return;
      root.querySelectorAll('[data-bic-preorder-open]').forEach(function (el) { el.hidden = true; });
      root.querySelectorAll('[data-bic-preorder-closed]').forEach(function (el) { el.hidden = false; });
      root.querySelectorAll('button[data-bic-preorder-disable]').forEach(function (btn) {
        btn.disabled = true;
        btn.setAttribute('aria-disabled', 'true');
        var label = btn.querySelector('[data-bic-preorder-label]') || btn;
        label.textContent = 'Not available';
      });
      if (root.closest('#cart')) blockCart = true;
    });
    document.documentElement.classList.toggle('bic-preorder-blocked', blockCart);
    return blockCart;
  }

  // Checkout guard. Dawn re-renders the cart contents on qty edits and
  // removals, so state is recomputed at submit time rather than cached.
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.id !== 'cart') return;
    if (!apply()) return;
    e.preventDefault();
    e.stopPropagation();
    var note = document.querySelector('#cart [data-bic-preorder-close] [data-bic-preorder-closed]');
    if (note) note.scrollIntoView({ block: 'center' });
  }, true);

  // Re-check shortly after cart interactions (the AJAX re-render lands after the click).
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('cart-items')) setTimeout(apply, 1200);
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }
  setInterval(apply, 60000);
})();
